import { Component } from '@angular/core';

@Component({
    selector: 'app-hcc-hyperlink-renderer',
    imports: [],
    template: `<a (click)="onClick($event)">{{ params?.value }}</a>`,
    styleUrl: './hcc-hyperlink-renderer.component.scss'
})
export class HccHyperlinkRendererComponent {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    this.params.context.componentParent.onDetailRowClicked(this.params);
  }
}